var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "idea_svg__Layer_1",
    width: 24,
    height: 24,
    strokeWidth: 1.5,
    color: "#000",
    "data-name": "Layer 1",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "idea_svg__defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-637a2287b95f902aafde8fbf-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__path8",
    d: "M8.18 18.68h7.64v1.91a1.91 1.91 0 0 1-1.91 1.91h-3.82a1.91 1.91 0 0 1-1.91-1.91z",
    className: "cls-637a2287b95f902aafde8fbf-1",
    style: {
      fill: "#cecabf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__path7",
    d: "M19.64 9.14a7.64 7.64 0 1 0-13.15 5.27 6.2 6.2 0 0 1 1.69 4.27h7.64a6.07 6.07 0 0 1 1.67-4.24 7.6 7.6 0 0 0 2.15-5.3Z",
    className: "cls-637a2287b95f902aafde8fbf-1",
    style: {
      fill: "#e5da02",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__path1",
    d: "M19.64 9.14a7.64 7.64 0 1 0-13.15 5.27 6.2 6.2 0 0 1 1.69 4.27h7.64a6.07 6.07 0 0 1 1.67-4.24 7.6 7.6 0 0 0 2.15-5.3Z",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__polygon1",
    d: "m12 8.18-1.91 2.86H12z",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__polygon2",
    d: "m12 12.96 1.91-2.87H12z",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__path2",
    d: "M8.18 18.68h7.64v1.91a1.91 1.91 0 0 1-1.91 1.91h-3.82a1.91 1.91 0 0 1-1.91-1.91z",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line2",
    d: "M.55 9.14h1.9",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line3",
    d: "M3.41 1.5h1.91",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line4",
    d: "M3.41 16.77h1.91",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line5",
    d: "M23.45 9.14h-1.9",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line6",
    d: "M20.59 16.77h-1.91",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "idea_svg__line7",
    d: "M20.59 1.5h-1.91",
    className: "cls-637a2287b95f902aafde8fbf-1"
  })));
};
export default SvgIdea;